module.exports = __webpack_public_path__ + "static/951679816.d58bd7c3.jpg";